import { Component, OnInit, Input } from '@angular/core';
import { ExportItems, TypeFormats } from '../../../../../../../shared/types/exportItem';
import { ExportFileService } from 'src/app/gamification/command-center/services/export-file.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import moment from 'moment';


@Component({
  selector: 'cv-awards-export-button',
  templateUrl: './awards-export-button.component.html',
  styleUrls: ['./awards-export-button.component.scss']
})
export class AwardsExportButtonComponent implements OnInit {

  @Input()
  startDate: string;
  @Input()
  endDate: string;
  @Input()
  filterText: string;
  
  public localizationDic: Map<string, string> = new Map();
  fileName = '';
  
  items: ExportItems = {
    excel: {
      getData: (format) => this.exportHistoryReport(format),
    },
    csv: {
      getData: (format) => this.exportHistoryReport(format),
    }
  };

  constructor(private exportFile: ExportFileService, private locService: CVLocalizationService) { }

  ngOnInit(): void {
    this.initAsync();
  }

  async initAsync() {
    this.localizationDic = await this.locService.GetSection("MarketPlace_Management");
  }

  async exportHistoryReport(format: TypeFormats) {
    if(!this.endDate || !this.endDate) return '';

    this.fileName = this.getLocalizationString("Awards_History", "Awards History") + ' ';
    const body = {
      from: moment(this.startDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
      to: moment(this.endDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
      filterText: this.filterText,
      format,
    }
    return this.exportFile.exportReport("/api/v1/gamification/awards-history/export", body);
  };

  getLocalizationString(key, defaultValue) {
    if (this.localizationDic && this.localizationDic.has(key))
      return this.localizationDic.get(key);
    return defaultValue;
  }

}
